"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgApis(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.84 13.204a.5.5 0 01.5.5V22.5a.5.5 0 01-1 0v-8.796a.5.5 0 01.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.556 19.215a.5.5 0 01.707 0l2.578 2.578 2.578-2.578a.5.5 0 01.707.707l-2.932 2.932a.5.5 0 01-.707 0l-2.931-2.932a.5.5 0 010-.707zM4.779 7.562a7.038 7.038 0 016.971-6.085 7.03 7.03 0 016.215 3.747A5.165 5.165 0 0123 10.391c0 2.272-1.175 3.586-2.34 4.309a6.454 6.454 0 01-2.283.858l-.013.002h-.005s-.002 0-.06-.447l.059.448a.5.5 0 01-.13-.992h.005l.027-.005c.025-.004.064-.01.115-.021a5.447 5.447 0 001.757-.693c.94-.583 1.868-1.606 1.868-3.46a4.165 4.165 0 00-4.324-4.164.5.5 0 01-.47-.286A6.033 6.033 0 005.725 8.158a.5.5 0 01-.602.46 3.004 3.004 0 00-3.623 2.94c0 .798.208 1.36.492 1.762.288.408.678.685 1.087.873.41.19.828.284 1.147.33a4.335 4.335 0 00.48.042h.026a.5.5 0 01.014 1l-.007-.5.007.5H4.728a2.208 2.208 0 01-.176-.005 5.293 5.293 0 01-.468-.047c-.382-.055-.9-.17-1.424-.412a3.674 3.674 0 01-1.484-1.203C.76 13.309.5 12.54.5 11.558a4.005 4.005 0 014.279-3.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.682 9.784a.5.5 0 01.5.5v9.773a.5.5 0 11-1 0v-9.773a.5.5 0 01.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.328 9.93a.5.5 0 01.707 0l2.932 2.932a.5.5 0 11-.707.707l-2.578-2.578-2.578 2.579a.5.5 0 01-.708-.708l2.932-2.931z"
  }));
}

var _default = SvgApis;
exports["default"] = _default;